module.exports = __webpack_public_path__ + "aq.no2.e3a445f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/aq.no2.jpg
// module id = qVQG
// module chunks = 0